'use client';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {useLinkStatus} from 'next/link';

export function CardPendingOverlay() {
  const {pending} = useLinkStatus();
  if (!pending) {
    return null;
  }
  return (
    <Box
      sx={theme => ({
        position: 'absolute',
        inset: 0,
        zIndex: 3,
        display: 'grid',
        placeItems: 'center',
        borderRadius: 'inherit',
        backgroundColor: theme.palette.colors.surface.darkOverlay,
      })}
    >
      <CircularProgress size={28} sx={theme => ({color: theme.palette.colors.text.neutral.inverse})} />
    </Box>
  );
}

CardPendingOverlay.displayName = 'CardPendingOverlay';
